<ng-template #templateModalForm role="document" let-modal>

  <app-page-comp-header [title]="title != undefined ? title : formTitle" [showBottomBorder]="false">
  </app-page-comp-header>

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form [formGroup]="templateForm" class="tablelist-form" autocomplete="off">
      <div class="modal-body">

        @if (!this.onlyShowBody) {
          @if(!this.hideMessageType) {
          <div class="mb-3 d-flex align-items-center gap-2">
            <label class="form-label fw-semibold mb-0 required">Message Type</label>
            <span class="text-muted font-normal">{{ messageType }}</span>
          </div>
          }

          <!-- Template Name -->
          <div class="mb-3">
            <label class="form-label fw-semibold required">Template Name</label>
            <input autocomplete="no-fill" type="text" id="templateName-field" class="form-control" placeholder="" formControlName="templateName" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['templateName'].errors }" />
          </div>

          @if(!this.hideFromOptions) {
          <!-- From Mobile Number -->
          <div class="mb-3">
            <div [ngClass]="{ 'is-invalid': templateFormSubmitted && ((formData['fromNumber'].value == null || formData['fromNumber'].value == '') &&
                                                                       (formData['useDefaultFromNumber'].value == null || formData['useDefaultFromNumber'].value == false ||
                                                                        this.companyDefaults.fromNumber == null || this.companyDefaults.fromNumber == '')) }">
              <label class="form-label fw-semibold required">From Mobile Number</label>
              <input autocomplete="no-fill" type="text" id="fromNumber-field" class="form-control" placeholder="" formControlName="fromNumber" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['fromNumber'].errors }"/>
              <div class="d-flex align-items-center gap-2 mt-2">
                <input type="checkbox" id="useDefaultFromNumber-field" class="form-check-input" formControlName="useDefaultFromNumber" (change)="onDefaultFromNumberChange($event)"/>
                <span class="text-muted small">Use Default -</span>
                @if(this.companyDefaults.fromNumber == undefined || this.companyDefaults.fromNumber.trim() == "") {
                  <span class="small text-danger">Default Not Set</span>
                } @else {
                  <span class="small text-success">{{this.companyDefaults.fromNumber}}</span>
                }
                <a href="javascript:void(0);" class="text-primary ms-1" id="editfromnumberdefault-btn" (click)="editFromNumberDefault()">
                  <i class="ri-pencil-fill fs-14"></i>
                </a>
              </div>
            </div>
            <div class="invalid-feedback">Either a from mobile number needs to be entered or the use default value needs to be selected.</div>
          </div>
          }

          <!-- Recipients -->
          <div class="mb-3 border rounded p-3" style="background-color: var(--vz-light, #f8f9fa);">

            <!-- Send To User -->
            <div class="d-flex align-items-center justify-content-between">
              <label class="form-check-label fw-semibold mb-0" for="sendToUser-field">Send To User</label>
              <div class="form-check form-switch form-switch-md mb-0">
                <input class="form-check-input" type="checkbox" role="switch" id="sendToUser-field" formControlName="sendToUser" (change)="onSendToUserChange()">
              </div>
            </div>

            <hr class="my-2">

            <!-- Send Elsewhere -->
            <div [ngClass]="{ 'is-invalid': (formData['sendToUser'].value == false) && (formData['sendElsewhere'].value == false) }">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center gap-1">
                  <label class="form-check-label fw-semibold mb-0" for="sendElsewhere-field">Send Elsewhere Mobile Number</label>
                  <i
                    title="To specifiy more than one destination mobile number, seperate each mobile number with a semicolon."
                    class="bi bi-info-circle text-secondary ms-1"
                    style="cursor: pointer;">
                  </i>
                </div>
                <div class="form-check form-switch form-switch-md mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="sendElsewhere-field" formControlName="sendElsewhere" (change)="onSendElsewhereChange()">
                </div>
              </div>

              <div [ngClass]="{ 'is-invalid': (templateFormSubmitted || this.showElsewhereMessage) && (formData['sendElsewhere'].value == true) &&
                                              ((formData['toNumber'].value == null || formData['toNumber'].value == '') &&
                                               (formData['useDefaultToNumber'].value == null || formData['useDefaultToNumber'].value == false ||
                                                this.companyDefaults.toNumber == null || this.companyDefaults.toNumber == '')) }">
                <input autocomplete="no-fill" type="text" [readonly]="!formData['sendElsewhere'].value" id="toNumber-field" class="form-control" placeholder="" formControlName="toNumber" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['toNumber'].errors }"/>
                <div class="d-flex align-items-center gap-2 mt-2">
                  <input type="checkbox" [readonly]="!formData['sendElsewhere'].value" class="form-check-input" formControlName="useDefaultToNumber" (change)="onDefaultToNumberChange()"/>
                  <span class="small" [ngClass]="{ 'disabled-class': !formData['sendElsewhere'].value }">Use Default -</span>
                  @if(this.companyDefaults.toNumber == undefined || this.companyDefaults.toNumber.trim() == "") {
                    <span class="small" [ngClass]="{ 'disabled-class': !formData['sendElsewhere'].value, 'text-danger': formData['sendElsewhere'].value }">Default Not Set</span>
                  } @else {
                    <span class="small" [ngClass]="{ 'disabled-class': !formData['sendElsewhere'].value, 'text-success': formData['sendElsewhere'].value }">{{this.companyDefaults.toNumber}}</span>
                  }
                  <a href="javascript:void(0);" class="text-primary ms-1" id="editsendelsewheredefault-btn" (click)="editSendElsewhereDefault()">
                    <i class="ri-pencil-fill fs-14"></i>
                  </a>
                </div>
              </div>
              @if(formData['useDefaultToNumber'].value != null && formData['useDefaultToNumber'].value == true && (this.companyDefaults.toNumber == null || this.companyDefaults.toNumber == '')) {
                <div class="invalid-feedback">Default value needs to be set.</div>
              } @else {
                <div class="invalid-feedback">Either a send elsewhere mobile number needs to be entered or the use default value needs to be selected.</div>
              }
            </div>
            <div class="invalid-feedback">At least one of send to user or send elsewhere need to be enabled.</div>

          </div>
        }

        <!-- Message -->
        <div class="mb-3" (click)="handleMouseClick($event)" (keyup)="handleKeyUp($event)">
          <label for="message-field" class="form-label fw-semibold required">
            Message
            <i
              title="To insert a system value, type @@ or hold the Ctrl key down and click where you want to place it."
              class="bi bi-info-circle text-secondary ms-1"
              style="cursor: pointer;">
            </i>
          </label>
          <textarea
            id="message-field"
            class="form-control resize-none"
            placeholder=""
            formControlName="message"
            data-lpignore="true"
            [ngClass]="{ 'is-invalid': this.getDodgySystemPlaceHolders(formData['message'].value) != '' }"
            rows="6">
          </textarea>
          <div class="invalid-feedback">Unknown system value(s) found - {{this.getDodgySystemPlaceHolders(formData['message'].value)}}</div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between align-items-center pt-3 border-top">
          <div>
            <button *ngIf="template.id > 0 && !onlyShowBody" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="saveAsNew()">Save As Copy</button>
          </div>
          <div class="hstack gap-2">
            @if(!embeddedFormMode) {
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm(templateModalAction);modal.close('Close click')">Cancel</button>
            }
            <button *ngIf="canEditTemplate" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="save()">Save</button>
            @if(!this.hideSaveAndEnable) {
              <button *ngIf="canEditTemplate && !alreadyEnabled" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="saveAndEnable()">Save & Enable</button>
            }
          </div>
        </div>

      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-input-modal-form #inputModalForm
  fieldCaption="System Value"
  formTitle="Insert System Value"
  [input0EnforceEmailValidation]="false"
  [input0EnforceMaxLengthValidation]="false"
  [input0EnforceRequiredValidation]="false"
  [input0Values]="this.templateReplacementsValues"
  (thisFormSaved)="inputModalFormSubmitted($event)"
></app-input-modal-form>
